import {useSelector} from "react-redux";
import Auth from "../reducers/auth/actions.js";

export const useCurrentUser = () => {
  return useSelector(Auth.user)
}
